// extracted by mini-css-extract-plugin
export default {"input_form":"InputTargets_input_form__u0ncx","input_button":"InputTargets_input_button__wsxLo","t_button":"InputTargets_t_button__II7z-"};